module.exports = __webpack_public_path__ + "static/lake-zoom-9774cf4bd05d7aa49d4788a9c21af371.jpg";